import axios from 'axios';

const AccountService = {
  async getAccounts() {
    const response = await axios.get('/account');

    return response.data;
  },
};

export default AccountService;
